import { render } from "./cloudflare_pdf.vue?vue&type=template&id=caa1f71c&scoped=true"
import script from "./cloudflare_pdf.vue?vue&type=script&lang=js"
export * from "./cloudflare_pdf.vue?vue&type=script&lang=js"

import "./cloudflare_pdf.vue?vue&type=style&index=0&id=caa1f71c&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa1f71c"]])

export default __exports__